import { render, staticRenderFns } from "./DirectorInfo.vue?vue&type=template&id=ce5df310"
import script from "./DirectorInfo.vue?vue&type=script&lang=js"
export * from "./DirectorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports